import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "src/hooks/useTranslation";
import {
  LegacyOwnerInfoContext,
  LegacyOwnerInfoForm,
  LegacyOwnerInfoState,
} from "./Legacy";
import { usePassportStore } from "src/stores/Passport.store";
import { OwnerInfoContext, OwnerInfoForm, OwnerInfoState } from "./";

export const PassportOwnerInfoForm = observer(() => {
  const translate = useTranslation();
  const passportStore = usePassportStore();

  return passportStore.isImprovementEnabled ? (
    <OwnerInfoContext.Provider
      value={new OwnerInfoState(translate, passportStore)}
    >
      <OwnerInfoForm />
    </OwnerInfoContext.Provider>
  ) : (
    <LegacyOwnerInfoContext.Provider
      value={new LegacyOwnerInfoState(translate, passportStore)}
    >
      <LegacyOwnerInfoForm />
    </LegacyOwnerInfoContext.Provider>
  );
});
